export class RegionModel {
    public id: number;
    public name: string;
    public isActive: boolean
}